import { motion } from "framer-motion";
import { MapPin, Instagram, Linkedin, Facebook, MessageCircle } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_one-guy-agency/artifacts/caw3knqv_logo%20arp%202026_mono_branca.png";
const WHATSAPP_LINK = "https://api.whatsapp.com/send/?phone=5508000155555&text&type=phone_number&app_absent=0";
const PHONE_DISPLAY = "0800 015 5555";

const socialLinks = [
  {
    name: "Instagram",
    icon: Instagram,
    url: "https://www.instagram.com/arp.chat/",
    handle: "@arp.chat",
  },
  {
    name: "LinkedIn",
    icon: Linkedin,
    url: "https://www.linkedin.com/company/arpchat",
    handle: "Grupo ARPChat",
  },
  {
    name: "Facebook",
    icon: Facebook,
    url: "https://www.facebook.com/profile.php?id=61561227399740",
    handle: "ARPChat",
  },
];

const locations = [
  {
    state: "Rio de Janeiro",
    address: "Avenida Perimetral Emílio de Menezes - Jardim Primavera, Duque de Caxias/RJ",
    cep: "CEP 25215-255",
  },
  {
    state: "Espírito Santo",
    address: "Rua República Árabe Siria, 248 - São Judas Tadeu, Guarapari/ES",
    cep: "CEP 29200-490",
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      id="unidades"
      className="bg-brand-dark pt-16 pb-8 border-t border-white/10"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="Grupo ARP Logo"
              className="h-28 md:h-32 w-auto object-contain mb-6"
            />
            <p className="text-white/60 text-sm mb-6 leading-relaxed">
              Ecossistema completo de comunicação e telefonia empresarial com IA.
            </p>
            {/* Phone Number Display */}
            <div className="mb-4">
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white hover:text-brand-ruby transition-colors"
                data-testid="footer-phone-display"
              >
                <MessageCircle className="w-5 h-5 text-brand-ruby" />
                <span className="font-bold text-lg">{PHONE_DISPLAY}</span>
              </a>
            </div>
            {/* CTA Button */}
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 bg-brand-ruby hover:bg-brand-ruby/90 rounded-lg transition-colors"
              data-testid="footer-cta-btn"
            >
              <MessageCircle className="w-5 h-5 text-white" />
              <span className="font-bold text-sm text-white">Fale pelo WhatsApp</span>
            </a>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="font-bold text-lg text-white mb-5">Redes Sociais</h4>
            <div className="space-y-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/60 hover:text-brand-ruby transition-colors"
                  data-testid={`footer-social-${social.name.toLowerCase()}`}
                >
                  <social.icon className="w-5 h-5" />
                  <span className="text-sm">{social.handle}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Locations */}
          <div className="lg:col-span-2">
            <h4 className="font-bold text-lg text-white mb-5">Unidades</h4>
            <div className="grid sm:grid-cols-2 gap-6">
              {locations.map((location, index) => (
                <div
                  key={location.state}
                  className="flex items-start gap-3"
                  data-testid={`footer-location-${index}`}
                >
                  <div className="flex-shrink-0 w-8 h-8 bg-brand-ruby/20 rounded-lg flex items-center justify-center mt-1">
                    <MapPin className="w-4 h-4 text-brand-ruby" />
                  </div>
                  <div>
                    <div className="font-bold text-white text-sm mb-1">
                      {location.state}
                    </div>
                    <p className="text-white/50 text-xs leading-relaxed">
                      {location.address}
                      <br />
                      {location.cep}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm text-center md:text-left">
            © Copyright Grupo ARP - {currentYear}. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/5 hover:bg-brand-ruby rounded-full flex items-center justify-center transition-colors"
                aria-label={social.name}
              >
                <social.icon className="w-5 h-5 text-white" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
